import { render, staticRenderFns } from "./coursequiz.html?vue&type=template&id=35d8d387&scoped=true&"
import script from "./coursequiz.js?vue&type=script&lang=js&"
export * from "./coursequiz.js?vue&type=script&lang=js&"
import style0 from "./coursequiz.css?vue&type=style&index=0&id=35d8d387&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d8d387",
  null
  
)

export default component.exports